
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mysql",
      function () {
        return require("private-next-pages/destinations/mysql.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mysql"])
      });
    }
  